import config from '../config/configureEnv';
import { getUserAuthDataFromLocalStorage } from '../utils';

export default function urlWrapper(url) {
  const accessToken = getUserAuthDataFromLocalStorage().accessToken;
  return `${config.bocaAPIUrl}${url}?access_token=${accessToken}`;
}



// WEBPACK FOOTER //
// ./src/utils/urlWrapper.js